import axios from "axios";
import { dominio } from "@/config/base";

const actions = {
  retrieveToken({ commit }, credentials) {
    return axios
      .post(`${dominio}/login/user`, {
        usuario: credentials.usuario,
        password: credentials.password,
      })
      .then((response) => {
        // Backend exitoso con ok=true
        if (response?.data?.ok === true) {
          const token = response.data.data.token;
          const user = response.data.data.user;

          localStorage.setItem("access_token", token);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("type", user.type);

          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          commit("retrieveToken", token);

          return response; // RESOLVE
        }

        // Caso 200 pero ok=false -> forzar catch en el componente
        const err = new Error("Login fallido");
        err.response = response;
        return Promise.reject(err);
      })
      .catch((error) => {
        // Dejar pasar el error al componente para manejo unificado
        return Promise.reject(error);
      });
  },

  destroyToken({ commit, getters }) {
    if (getters.loggedIn) {
      return axios
        .post(`${dominio}/logout`)
        .then((response) => {
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          localStorage.removeItem("type");
          commit("destroyToken");
          delete axios.defaults.headers.common["Authorization"];
          return response;
        })
        .catch((error) => {
          // Limpiar igualmente en error para asegurar desconexión local
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          localStorage.removeItem("type");
          commit("destroyToken");
          delete axios.defaults.headers.common["Authorization"];
          return Promise.reject(error);
        });
    }
    // si no estaba logueado, devolver una promesa resuelta
    return Promise.resolve();
  },
};

export default actions;
